import React from 'react'
import { Step } from 'semantic-ui-react'

function OrderStep(props){
    return (
    <Step.Group ordered size='mini'>
        <Step completed={props.step > 1} active={props.step == 1}>
            <Step.Content>
                <Step.Title>Abone Bilgileri</Step.Title>
                <Step.Description>Ödeme talimatı vermek istediğiniz abonelik bilgileri</Step.Description>
            </Step.Content>
        </Step>

        <Step completed={props.step > 2} active={props.step == 2} >
            <Step.Content>
                <Step.Title>Ödeme Yöntemi</Step.Title>
                <Step.Description>Paycell cüzdanda kayıtlı kartlar</Step.Description>
            </Step.Content>
        </Step>

        <Step completed={props.step > 3} active={props.step == 3}>
            <Step.Content>
                <Step.Title>Talimat Özet</Step.Title>
            </Step.Content>
        </Step>

        <Step completed={props.step > 4} active={props.step == 4}>
            <Step.Content>
                <Step.Title>Talimat Sonuç</Step.Title>
            </Step.Content>
        </Step>

    </Step.Group>

    )
}

export default OrderStep;